import { iCompProps } from "../types/competition"
import { Inputs } from "../types/inputs"
import { useState } from "react"
import dayjs from "dayjs"
import advancedFormat from 'dayjs/plugin/advancedFormat';
import PrivacyModal from "./PrivacyModal"
import TCsModal from "./TCsModal"
import { useForm, SubmitHandler } from "react-hook-form"
import { submitEntry, subscribeToMarketing } from "../services/api"
import { useCookies } from "react-cookie";
import { SquareLoader } from "react-spinners"
const referer = window.siteVar.referer
import { postCodeLookup } from "../services/api"
dayjs.extend(advancedFormat);

const Comp:React.FC< iCompProps > = ({ competition }) => {

    const [ cookies ] = useCookies()
    let socialCookies = cookies.smid || cookies.socialCookies || false

let indefinite = dayjs(competition.ends).diff(dayjs(competition.starts), "year") >= 10 ? true : false


const formattedEndDate = dayjs(competition.ends).format('Do MMMM YY').toLocaleString() 

    const [page, setPage] = useState(1)
    const [addresses, setAddresses] = useState<string[]>([])
    const [manualAddress, showManualAddress] = useState(false)
    const [showSpinner, setSpinner] = useState(false)

    const style = {
        backgroundImage : `url("${page === 1 ? competition.backgroundImg1 : competition.backgroundImg2}")`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: '100vh',
        minHeight: '100vh',
    }
    const {
        register,
        handleSubmit,
        reset,
        setError,
        formState:{errors},
        clearErrors
      } = useForm<Inputs | any>()

    const searchPostcode = async (postcode: string) => {
        try {
    
        let addressResults = !manualAddress && await postCodeLookup(postcode, window.siteVar.referer)
         if(addressResults && addressResults?.length > 0){
             setAddresses(addressResults)
             clearErrors('postcode')
        }else{
            setError('postcode',{
                type: 'manual',
                message : '❔ Address not found. Add manually?'
            })
        }
        }catch(err){
            setPage(1)
            throw new Error(`${err}  - error in postcode search`)
        }
       }

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        try {
            setSpinner(true)
            const res = await subscribeToMarketing(data, socialCookies, referer); //first add email address to marketing email subscription db
            if (res) {
              const submit = await submitEntry(data,competition, referer); //then submit competition entry
               if(submit?.acknowledged) 
                setPage(3)
                reset()
                 setTimeout(() => { // Set the timeout
                    window.location.reload();
                 }, 4000) 
             
            }
        } catch (error) {
            setPage(1)
            throw new Error(`Error in subscription or submission | ${error}`);
        }
    }

return (
<>  
    <section className="container-fluid p-0 d-flex flex-column h-100 justify-content-center align-items-center comp_container position-relative" style={style}>

    { page === 1 &&
        <>
        <div className="bg-dark bg-opacity-75 col col-11 col-lg-6 m-3 p-3 text-center" style={{borderRadius:'15px'}}>


        { competition?.title && (
            <div dangerouslySetInnerHTML={{ __html: competition.title}} className="text-light fs-4"></div>
        )}
         <hr className="tf-orange h-"/>
          <button className="btn btn-dark px-3 py-2 rounded-3 mb-3 mt-3 font-din fs-5 border border-warning col-12 col-lg-5 col-xl-4 tf-orange" onClick={() => setPage(2)}>
            PRESS TO ENTER
          </button>
        <div className="container d-flex justify-content-around mt-4 p-0">
        { competition?.logo && competition.logo.map((logo:string, index:number) => {
            return (
                <span  key={'_logo_' + index} className="col-4 my-auto">
                    <img src={logo} alt="partner logo" className="img-fluid"></img>
                </span>
            )
        })}
        </div>
        </div>
        { competition?.images && competition.images.length > 0 &&
        <div className="position-absolute bottom-0 start-0 end-0 d-none d-lg-flex justify-content-center flex-wrap gap-2 mb-5 ">
        { competition.images.map((image:string, index:number) => {
            return (
                <span key={'_image_' + index} className="d-inline-block overflow-hidden" style={{width:'250px', height:'250px', borderRadius:'8px'}}>
                    <img src={image} alt="competition" className="w-100 h-100" style={{objectFit:'cover'}}></img>
                </span>
            )
        })}
        </div>
        }
        </>
    }
    { page === 2 &&
        <div className="bg-dark bg-opacity-75 col col-11 p-3 text-center position-relative" 
             style={{borderRadius:'15px'}}>
    <div className="row d-flex flex-column flex-md-row">
        <div className="col-12 col-md-6 p-3">
                { competition?.title && (
            <div dangerouslySetInnerHTML={{ __html: competition.title}} className="text-light fs-3"></div>
        )}
       
         <div dangerouslySetInnerHTML={{__html: competition.copy }} className="text-light p-3 pe-0"/>

            <div className="d-none d-md-block text-light">
                <div className="container d-flex flex-column flex-lg-row justify-content-between my-4 px-4 px-lg-3">
        {competition?.logo && competition.logo.map((logo:string, index:number)=> {
            return (
                <span  key={'_logo_' + index} className="col my-auto px-lg-3">
                    <img src={logo} alt="partner logo" className="img-fluid"></img>
                </span> 
            )
        })}
        </div>
        </div>
        
         <ul className="py-3 ps-1">
        {competition?.inclusions?.map((inclusion,index) => {
            
            return (
                <li className="text-light" key={'inclusion-'+ index} dangerouslySetInnerHTML={{__html: inclusion}}></li>
            )
        })}
        </ul>



         </div>
         <div className="col-12 col-md-6 p-3">
            <form className="w-100 d-flex flex-column gap-3 p-3" onSubmit={handleSubmit(onSubmit)} autoComplete="off">

                {/* ////mandatory inputs//// */}
                    <select key= {'input-title'}
                            autoComplete="new-password"
                           {...register(`title`, { required: true })} 
                           className="p-3 border-0 form-control">
                            <option value="" disabled selected>Title</option>
                            <option value="Dr">Dr</option>
                            <option value="Mr">Mr</option>
                            <option value="Mrs">Mrs</option>
                            <option value="Ms">Ms</option>
                            <option value="Miss">Miss</option>
                    </select>
                    {errors?.title && (<small className="text-warning">❌  Title required.</small>)}
                    <input type="text"
                           autoComplete="new-password"
                           key= {'input-firstname'}
                           {...register(`firstname`, { required: true, minLength:2, pattern : /^[a-zA-Z]+(?:[' -][a-zA-Z]+)*$/ })} 
                           placeholder="First Name" 
                           className="p-3 border-0 form-control">
                    </input>
                    {errors?.firstname && (<small className="text-warning">❌  Name required. Min length 2.</small>)}
                    <input type="text"
                           autoComplete="new-password"
                           key= {'input-lastname'}
                           {...register(`lastname`, { required: true, minLength:2, pattern : /^[a-zA-Z]+(?:[' -][a-zA-Z]+)*$/ })} 
                           placeholder="Last Name" 
                           className="p-3 border-0 form-control">
                    </input>
                    {errors?.lastname && (<small className="text-warning">❌  Name required. Min length 2.</small>)}
                    <input type="tel"
                           autoComplete="new-password"
                           key= {'input-phone'}
                           {...register(`telephone`, { required: true, minLength:10, pattern : /^[0-9]*$/ })} 
                           placeholder="Phone" 
                           className="p-3 border-0 form-control">
                    </input>
                    {errors?.telephone && (<small className="text-warning">❌  Phone number required. Min 10 digits.</small>)}
                    <input type="email"
                           autoComplete="new-password"
                           key= {'input-email'}
                           {...register(`email`, {required : true, pattern: /^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gim })} 
                           placeholder="Email" 
                           className="p-3 border-0 form-control">
                    </input>
                     {errors?.email && (<small className="text-warning">❌  Must be a valid email address.</small>)}
                
                    {manualAddress ?
                    <>
                    <small className="text-light">Please enter your address manually</small>
                     <input type="text"
                           autoComplete="new-password"
                           key="input-address1"
                           {...register(`address1`, { required: true })}
                           placeholder="Address 1"
                           className="p-3 border-0 form-control"/>
                           {errors?.address1 && (<small className="text-warning">❌  Address Required</small>)}
                    <input type="text"
                           autoComplete="new-password"
                           key="input-address2"
                           {...register(`address2`, { required: true })}
                           placeholder="Address 2"
                           className="p-3 border-0 form-control"/>
                           {errors?.address2 && (<small className="text-warning">❌  Address Required</small>)}
                    <input type="text"
                           autoComplete="new-password"
                           key="input-address3"
                           {...register(`address3`)}
                           placeholder="Address 3"
                           className="p-3 border-0 form-control"/> 
                    </> : ''
                    }
                    
                { addresses && addresses?.length ?
                <>
                <select className="p-3 border-0 form-control" {...register(`selectedAddress`)} autoComplete="new-password">
                    {addresses.map((address) => {
                        return (
                            
                            <option value={address}key={'address-'+ address} >{address}</option>
                          
                        )
                    })}
                </select>
                </> : ''
                }
                    <input type="text"
                           autoComplete="new-password"
                           key="input-postcode"
                           {...register(`postcode`)}
                           placeholder={window.siteVar.referer === 'UK' ? "Postcode" : 'Eircode'}
                           className="p-3 border-0 form-control"
                           onChange={(e)=>e.target.value.length > 3 && searchPostcode(e.target.value)}/>
                       {errors?.postcode && (
                         <small className="text-start text-warning hover" 
                           onClick={()=>{showManualAddress(true);setAddresses([]);clearErrors('postcode')}}>{errors.postcode.message?.toString()}</small>
                    )}
                   

                {/* ////optional inputs//// */}

           {/* { competition?.inputs.map((input,index:number) => {
                  
                        return (
                            <input type="text"
                                   autoComplete="new-password"
                                   key= {'input-' + index}
                                   {...register(`${input.type}`, { required: true })} 
                                   placeholder={input.placeHolder} 
                                   className="p-3 border-0 form-control">
                            </input>
                        )
                    
                })} */}
               
    <div className="d-block d-md-none text-light">
         {indefinite ? 
        (
        <></>
        ) 
        : 
        (
        <p className={"btn-group pull-right"}>Entry closes on <strong><b>{formattedEndDate}</b></strong></p>
        )
        }
            <p>Trailfinders will <strong><b>NEVER</b></strong> pass your details to third parties.</p>
                <small>By entering the competition you agree to receive marketing from Trailfinders.<br />You can opt out at any time.</small>
                <a type="button"data-bs-toggle="modal" data-bs-target="#privacyModal" className="mt-3 d-block mx-auto">
                    <p className="d-inline">Privacy Policy</p>
                </a>
    </div>
                
    <label className="d-flex justify-content-center text-light">
        Agree to  <a type="button"data-bs-toggle="modal" data-bs-target="#TCsModal" className="ps-1 text-warning">terms &amp; conditions</a>
            <input type="checkbox" className=" ms-3 form-check-input" {...register(`agreeTerms`, { required: true })}></input>
    </label>
               {errors?.agreeTerms && (<p><small className="text-warning">❌  Click to confirm you're happy with the terms before continuing.</small></p>)}
    <button className="btn btn-warning bg-tf-orange p-3 rounded-3 mb-3 font-montserrat fw-bold" type="submit">
        SEND MY ENTRY!
    </button>
</form>
<div className="text-light">
     {indefinite ? 
        (
        <></>
        ) 
        : 
        (
        <p className={"btn-group pull-right"}>Entry closes on  <strong className="ms-1"><b>{formattedEndDate}</b></strong></p>
        )
        }
                <p>Trailfinders will <strong><b>NEVER</b></strong> pass your details to third parties.</p>
               

                <a type="button"data-bs-toggle="modal" data-bs-target="#privacyModal" className="mt-3 mx-auto d-none d-md-block">
                    <p className="d-inline text-warning">Privacy Policy</p>
                </a>

</div>
     <div className="d-block d-md-none">
         
                <div className="container d-flex justify-content-around">
        {competition?.logo && competition.logo.map((logo:string, index:number)=> {
            return (
                <span  key={'_logo_' + index} className="col px-2">
                    <img src={logo} alt="partner logo" className="img-fluid"></img>
                </span> 
            )
        })}
        </div>
        </div>     
    
        <span className="position-absolute bottom-0 end-0 p-3">
        {showSpinner &&
            <SquareLoader size={15}/>}
        </span>
        </div>
        </div> 
        </div>
    }
    { page === 3 &&
        <div className="bg-dark bg-opacity-50 col col-11 col-lg-3 m-3 p-3 text-center" style={{borderRadius:'15px'}}>
        
         <h3 className="mb-5 font-din fw-bold text-light">Your entry was successful!<br />Good luck!</h3>
        <div className="container d-flex justify-content-around mt-4">
        { competition?.logo && competition.logo.map((logo:string, index:number) => {
            return (
                <span  key={'_logo_' + index}>
                    <img src={logo} alt="partner logo" className="img-fluid col"></img>
                </span> 
            )
        })}
        </div>
        </div>
    }
      
    </section> 

    {/* ///modals    */}
    <PrivacyModal/>
    <TCsModal terms={competition.terms}/>
</>
)
}
export default Comp
